import { useState } from 'react';
import { node, number } from 'prop-types';
import { Fade, Tooltip as MuiTooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import useIsPrinting from '../../utilities/PrintUtilities';

const useStyles = makeStyles((theme) => ({
    popper: {
        zIndex: 9999,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #cccccc',
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1),
        margin: (props) => props.offset,
        pointerEvents: 'none',
        opacity: 0.9,
        boxShadow: `0 3px 6px ${theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.28)' : 'rgba(100, 100, 100, 0.28)'}`,
        whiteSpace: 'nowrap',
    },
    tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        border: 0,
        borderRadius: 0,
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        maxWidth: 1000,
        padding: 0,
    },
}));

/**
 * A tooltip component that will follow the mouse as it moves.
 */
export default function Tooltip({ offset, children, ...otherProps }) {
    const [position, setPosition] = useState({ x: -9999, y: -9999 });
    const classes = useStyles({ offset });
    const isPrinting = useIsPrinting();

    function handleMouseMove(e) {
        const { pageX: x, pageY: y } = e;
        setPosition({ x, y });
    }

    // Don't render tooltips when printing.
    if (isPrinting) return children;

    return (
        <MuiTooltip
            enterTouchDelay={0}
            leaveTouchDelay={0}
            classes={classes}
            onMouseMove={handleMouseMove}
            PopperProps={{
                anchorEl: {
                    clientHeight: 0,
                    clientWidth: 0,
                    getBoundingClientRect: () => ({
                        top: position.y,
                        left: position.x,
                        right: position.x,
                        bottom: position.y,
                        width: 0,
                        height: 0,
                    }),
                },
            }}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 0 }}
            {...otherProps}
        >
            {children}
        </MuiTooltip>
    );
}

Tooltip.propTypes = {
    // How far to offset to the tooltip from the mouse location.
    offset: number,
    children: node.isRequired,
};

Tooltip.defaultProps = {
    offset: 25,
};
